import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { timeWindowFormatter } from '../../lib/dates';
import { PickupCalendarContainer } from './PickupStyles';
import PickupCarousel from './PickupCarousel';

const mapStateToProps = ({
  page: { countryCode } = {},
  retailerSettings: { branding: { brand_call_to_action: ctaColor } = {} } = {},
}) => ({ ctaColor, countryCode });

const TimePicker = ({ time, selected, ctaColor, onClick, countryCode }) => (
  <PickupCalendarContainer selected={selected} ctaColor={ctaColor} onClick={onClick}>
    <strong>{timeWindowFormatter(time, countryCode)}</strong>
  </PickupCalendarContainer>
);

TimePicker.defaultProps = {
  selected: false,
  ctaColor: '#000000',
  onClick: () => {},
};

TimePicker.propTypes = {
  time: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  ctaColor: PropTypes.string,
  onClick: PropTypes.func,
  countryCode: PropTypes.string.isRequired,
};

const PickupTimeWindows = ({
  ctaColor,
  timeWindows,
  allDayString,
  onClick,
  selectedPickupTime,
  countryCode,
}) => {
  if (!timeWindows || !timeWindows.length) {
    return (
      <p
        style={{ color: '#7A7A7A', margin: '1.5rem auto', fontFamily: 'inherit' }}
        dangerouslySetInnerHTML={{
          __html: allDayString,
        }}
      />
    );
  }
  return (
    <PickupCarousel
      items={timeWindows}
      render={(time) => (
        <TimePicker
          time={time}
          ctaColor={ctaColor}
          selected={selectedPickupTime === time}
          onClick={() => onClick(time)}
          countryCode={countryCode}
        />
      )}
      slidesToShow={timeWindows.length}
    />
  );
};

PickupTimeWindows.defaultProps = {
  ctaColor: '#000000',
  timeWindows: [],
  selectedPickupTime: '',
  allDayString: '',
};

PickupTimeWindows.propTypes = {
  onClick: PropTypes.func.isRequired,
  timeWindows: PropTypes.arrayOf(PropTypes.string),
  selectedPickupTime: PropTypes.bool,
  openAllDay: PropTypes.bool.isRequired,
  ctaColor: PropTypes.string,
  allDayString: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(PickupTimeWindows);
